export default __webpack_public_path__ + "static/media/logo.8b9eb740.svg";